import store from "../store";
import roles from "./roles";

export default {
  computed: {
    isImpersonation: function() {
      return store.getters.isAuthorized(roles.impersonation);
    },
    isFacultyHead: function() {
      return store.getters.isAuthorized(roles.facultyHead);
    },
    isEmployee: function() {
      return store.getters.isAuthorized(roles.employee);
    },

    isEmployeesViewer: function() {
      return store.getters.isAuthorized(roles.employeesViewer);
    },

    isEmployeesManager: function() {
      return store.getters.isAuthorized(roles.employeesManager);
    },

    isOverloadsManager: function() {
      return store.getters.isAuthorized(roles.overloadsManager);
    },

    isDegreeCoordinator: function() {
      return store.getters.isAuthorized(roles.degreeCoordinator);
    },
    isViewOnly: function() {
      return store.getters.isAuthorized(roles.viewOnly);
    },
    isExpertsEditor: function() {
      return store.getters.isAuthorized(roles.expertsEditor);
    },
    isExpertsAdmin: function() {
      return store.getters.isAuthorized(roles.expertsAdmin);
    },
    isTranslationalTeam: function() {
      return store.getters.isAuthorized(roles.translationalTeam);
    },
    isExpertsViewer: function() {
      return store.getters.isAuthorized(roles.expertsViewer);
    },
    isBuyoutManager: function() {
      return store.getters.isAuthorized(roles.buyoutManager);
    },
    isBuyoutViewer: function() {
      return store.getters.isAuthorized(roles.buyoutViewer);
    },
    // Oct. 20, 2021, Marina: The next 3 functions - SP roles: viewer, manager, submitter
    isSPManager: function() {
      return store.getters.isAuthorized(roles.spManager);
    },
    isSPViewer: function() {
      return store.getters.isAuthorized(roles.spViewer);
    },
    isSPSubmitter: function() {
      return store.getters.isAuthorized(roles.spSubmitter);
    },
    isWorkloadsViewer: function() {
      return store.getters.isAuthorized(roles.workloadsViewer);
    },
    isWorkloadsManager: function() {
      return store.getters.isAuthorized(roles.workloadsManager);
    },
    isWorkloadsSubmitter: function() {
      return store.getters.isAuthorized(roles.workloadsSubmitter);
    },

    isAdminViewer: function() {
      return store.getters.isAuthorized(roles.adminViewer);
    },

    isAdminSupervisor: function() {
      return store.getters.isAuthorized(roles.adminSupervisor);
    },
    isCourseEquivalentsManager: function() {
      return store.getters.isAuthorized(roles.courseEquivalentsManager);
    },
    isCourseEquivalentsViewer: function() {
      return store.getters.isAuthorized(roles.courseEquivalentsViewer);
    },
    isCourseEquivalentsFaculty: function() {
      return store.getters.isAuthorized(roles.courseEquivalentsFaculty);
    },
  },
};
